import {
	find,
	identity,
	mergeAll,
	mergeDeepWith,
	omit,
	path,
	pathOr,
	pipe,
	prop,
	propEq,
} from "ramda";

import { MEDIA_ALPHA_FEED, ROUTING_PARAMS } from "../../config/constants";
import { MEDIA_ALPHA_CARRIER_MAPPING } from "../../config/media-alpha";
import {
	filterAdNetworkCompanies,
	filterMediaAlphaByMinimumBid,
} from "../helpers/filters";

export const getIsMediaAlphaTargetedPath = (state) =>
	pathOr(false, [ROUTING_PARAMS, "isMediaAlphaTargetedPath"], state);

export const getMediaAlphaCompanies = (state) =>
	path([MEDIA_ALPHA_FEED, "feed", "ads"], state);

export const processMediaAlphaCompanies = (
	contentfulCompanies,
	mediaAlphaCompanies,
	mediaAlphaMinimumBid,
) => {
	const companies = contentfulCompanies.map((company) => {
		const matcherProp =
			prop(company.fields.companySlug, MEDIA_ALPHA_CARRIER_MAPPING) ||
			company.fields.companyName;
		const matchedPayloadCompany =
			find(propEq("carrier", matcherProp))(mediaAlphaCompanies) ||
			find(propEq("contentful_company_name", matcherProp))(mediaAlphaCompanies);
		if (matchedPayloadCompany) {
			if (!prop("is_direct", matchedPayloadCompany)) {
				// MediaAlpha company.
				return mergeDeepWith(mergeAll, company, {
					fields: { ...matchedPayloadCompany, isMediaAlpha: true },
				});
			} else {
				// Direct partner injection
				const { fields } = company; // destructure fields from company
				const withOmittedFields = omit(
					["isPurelyMediaAlphaPartner", "useMediaAlphaClickUrl"],
					fields,
				);
				const companyWithoutFields = omit(["fields"], company);
				const directPartner = mergeDeepWith(mergeAll, companyWithoutFields, {
					fields: { ...withOmittedFields },
				});
				return mergeDeepWith(mergeAll, directPartner, {
					fields: { ...matchedPayloadCompany },
				});
			}
		} else return company;
	});

	// Filter by minimum bid if applicable
	const filterByMinimumBid = mediaAlphaMinimumBid
		? filterMediaAlphaByMinimumBid(mediaAlphaMinimumBid)
		: identity;

	return pipe(filterAdNetworkCompanies, filterByMinimumBid)(companies);
};
